import { render, staticRenderFns } from "./Paid.vue?vue&type=template&id=f13f98dc&scoped=true"
import script from "./Paid.vue?vue&type=script&lang=js"
export * from "./Paid.vue?vue&type=script&lang=js"
import style0 from "./Paid.vue?vue&type=style&index=0&id=f13f98dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13f98dc",
  null
  
)

export default component.exports